import { Textarea } from '@nextui-org/react';
import { useFormContext } from 'react-hook-form';

import { AiEmailAssistantForm } from '@/schemas/ai-email-assistant';

export const PastConversationsSection = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<AiEmailAssistantForm>();

  return (
    <div className="space-y-4">
      <div>
        <label className="mb-1 block text-white">
          Do you want to include any previous conversations with the donor?
        </label>
        <Textarea
          {...register('pastConversations')}
          placeholder="Include any previous email exchanges, meeting notes, or important interactions that could help provide context for this email."
          minRows={3}
          maxRows={8}
          classNames={{
            input: 'resize-none !outline-none',
            inputWrapper: '!bg-white border-1 border-[#CBD5E1] shadow-none'
          }}
        />
        {errors.pastConversations?.message && (
          <span className="text-sm text-buttonOrange">{errors.pastConversations.message}</span>
        )}
      </div>
    </div>
  );
};
